import { render, staticRenderFns } from "./topic.vue?vue&type=template&id=2cf7b1db&scoped=true&"
import script from "./topic.vue?vue&type=script&lang=js&"
export * from "./topic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf7b1db",
  null
  
)

export default component.exports